import styled from 'styled-components';

const StyledGlobal = styled.div`
  width: 100%;
  height: 100vh;
  background: var(--color-grey);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default StyledGlobal;